import { LocationsStateType } from './state'

export interface LocationsGettersType {
  getLocationsById: (state: LocationsStateType, id: string) => LocationsStateType['location']
  //getLocationsByCode: (state: LocationsStateType, code: string) => LocationsStateType['location']
  //getLocationsByCompanyId: (state: LocationsStateType, companyId: number) => LocationsStateType['locations']
  getLocationsByTypeUse: (state: LocationsStateType, typeUse: string) => LocationsStateType['locations']
  getLocationsByParentId: (state: LocationsStateType, parentLocationId: string) => LocationsStateType['locations']
}

export const LocationsGetters = {
  getLocationsById: (state: LocationsStateType) => (id: string) => {
    return state.locations.find(location => location.id === id)
  },
  // getLocationsByCode: (state: LocationsStateType) => (code: string) => {
  //   return state.locations.find(location => location.code === code)
  // },
  // getLocationsByCompanyId: (state: LocationsStateType) => (companyId: number) => {
  //   return state.locations.filter(location => location.companyId === companyId)
  // },
  getLocationsByTypeUse: (state: LocationsStateType) => (typeUse: string) => {
    return state.locations.filter(location => location.typeUse === typeUse)
  },
  getLocationsByParentId: (state: LocationsStateType) => (parentLocationId: string) => {
    return state.locations.filter(location => location.parentLocationId === parentLocationId)
  },
}
